module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"password_field":"Пароль","login_button":"Войти","code_field":"Код","code_ttl":"Время до повторной отправки","next":"Далее","sec":"сек."},"en":{"password_field":"Password","login_button":"Login","code_field":"Code","code_ttl":"Time to repeat sending","next":"Next","sec":"sec."}}')
  delete Component.options._Ctor
}
